import api from '../../../lib/api';

export type BmpCustomFieldSource = 'PO_NUMBER' | 'DEFEO_TICKET_NUMBER';
export type QboInvoiceCustomFieldOption = {
  definitionId: string;
  name: string;
  type: 'StringType';
  writeMode: 'REST_LEGACY';
  invoiceAvailability: 'SALES_FORMS_ENABLED_UNVERIFIED_FOR_INVOICE';
};
export type QboCustomFieldMapping = {
  source: BmpCustomFieldSource;
  definitionId: string;
  savedName: string;
  realmId: string;
  valid: boolean;
  updatedAt: string;
};
export type InvoiceCustomFieldSettingsResponse = {
  catalog: {
    realmId: string;
    fields: QboInvoiceCustomFieldOption[];
    source: 'QBO_REST_PREFERENCES';
    coverage: 'LEGACY_REST_ONLY';
  };
  mappings: Record<BmpCustomFieldSource, QboCustomFieldMapping | null>;
};

export async function getInvoiceCustomFieldSettings() {
  const { data } = await api.get<InvoiceCustomFieldSettingsResponse>(
    '/integrations/blume/invoice-custom-fields-settings'
  );
  return data;
}

export async function saveInvoiceCustomFieldSettings(
  mappings: Record<BmpCustomFieldSource, string | null>
) {
  const { data } = await api.put<InvoiceCustomFieldSettingsResponse>(
    '/integrations/blume/invoice-custom-fields-settings',
    { mappings }
  );
  return data;
}
